module.exports = __webpack_public_path__ + "img/app-tcby-menu.93ce6244.png";